import { AlertToken } from "../redux/alerts";
import { API_URL, APP_ID, AUTH_URL } from "../redux/Consts";
import { devicesReqOptions } from "../redux/devices";
import { DeviceStatusesNames } from "../redux/devicesStatuses";
import { residentsReqOptions } from "../redux/residents";

export class EndPoints {
  static baseurl = (endpoint: string): string => {
    return `${API_URL()}${endpoint}`;
  };

  static authUrl = (endpoint: string): string => {
    return `${AUTH_URL()}${endpoint}`;
  };

  static withOptions = (urlSTR: string, options: any): URL => {
    const url = new URL(urlSTR);
    Object.keys(options).map((el) => {
      const key = encodeURI(el);
      const value = encodeURI(options[el]);
      url.searchParams.append(key, value);
      return null;
    });
    return url;
  };
  static withSameOption = (
    urlSTR: string,
    options: any[],
    optionName: string
  ): URL => {
    const url = new URL(urlSTR);
    options.map((el) => {
      url.searchParams.append(optionName, el);
      return null;
    });
    return url;
  };

  static withIncludeOptions = (
    urlSTR: string,
    options: residentsReqOptions | devicesReqOptions
  ): URL => {
    const url = new URL(urlSTR);
    options.include.forEach((el: any) => {
      url.searchParams.append("include", el);
    });

    Object.keys(options).map((el) => {
      const key = encodeURIComponent(el);
      if (key !== "include") {
        const value = encodeURIComponent(options[el] as string);
        url.searchParams.append(key, value);
      }
      return null;
    });
    return url;
  };

  static validateTokenURL = (token: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/invites/${token}`));
  };

  static signUpURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/invites/signup`));
  };

  static linkAccountURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/invites/link`));
  };

  static usersProfileURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/profile`));
  };

  static usersInfoURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/info`));
  };

  // static usernameCheckURL = (): URL => {
  //     return new URL(EndPoints.baseurl(`api/v1/users/usernameCheck`));
  // };

  static organizationsURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/organizations`));
  };

  static organizationsInfoByIdURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/organizations/info?include=tree`));
  };

  static organizationsInfoURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/organizations/info`));
  };

  static getUsersURL = (): URL => {
    return new URL(EndPoints.baseurl("api/v1/users"));
  };

  static changePassword = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/changePassword`));
  };

  static usersAvatar = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/avatar`));
  };

  static activityURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/activity`));
  };

  static alertsURL = (
    residentId: string,
    alertType: AlertToken = undefined
  ): URL => {
    if (alertType) {
      return new URL(
        EndPoints.baseurl(`api/v1/residents/${residentId}/alerts/${alertType}`)
      );
    }
    return new URL(EndPoints.baseurl(`api/v1/residents/${residentId}/alerts`));
  };

  static residentsURL = (options: residentsReqOptions): URL => {
    return EndPoints.withIncludeOptions(
      EndPoints.baseurl(`api/v1/residents`),
      options
    );
  };
  static residentsNoOptionsURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents`));
  };

  static residentsBatchURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/batch`));
  };
  static oneResidentURL = (residentId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/${residentId}`));
  };

  static getDevicesURL = (options: devicesReqOptions): URL => {
    return EndPoints.withIncludeOptions(
      EndPoints.baseurl(`api/v1/devices`),
      options
    );
  };

  static getOneDeviceURL = (deviceId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/${deviceId}`));
  };

  static rulesFallPreventionResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/rules/preventions/fall`)
    );
  };

  static rulesResidentUrl = (residentId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/${residentId}/rules`));
  };

  static rulesEpilepsyResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(
        `api/v1/residents/${residentId}/rules/preventions/epilepsy`
      )
    );
  };

  static rulesPressureUlcersResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(
        `api/v1/residents/${residentId}/rules/protocols/pressureUlcers`
      )
    );
  };

  static rulesFallDetectedResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(
        `api/v1/residents/${residentId}/rules/preventions/falldetected`
      )
    );
  };

  static rulesPostureResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/rules/posture`)
    );
  };

  static rulesDrinkingResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/rules/drinking`)
    );
  };
  static rulesOccupancyResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/rules/bedOccupancy`)
    );
  };

  static rulesCallButtonResidentUrl = (residentId: string): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/rules/callButton`)
    );
  };
  static residentDevicesUrl = (residentId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/${residentId}/devices`));
  };
  static oneResidentDevicesUrl = (
    residentId: string,
    deviceId: string
  ): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/residents/${residentId}/devices/${deviceId}`)
    );
  };

  static deviceStatusesUrl = (
    deviceId: string,
    status: DeviceStatusesNames
  ): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/devices/${deviceId}/statues/${status}`)
    );
  };

  static devicesURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices`));
  };

  static devicesBatchURLOLD = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/batch`));
  };

  static devicesBatchURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/move/batch`));
  };

  static residentsDevicesBatchURL = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/devices/batch`));
  };

  static historyUrl = (period: string): URL => {
    return new URL(
      EndPoints.baseurl(`api​/v1​/audit​/organizations?period=${period}`)
    );
  };

  static notificationUrl = (deviceId: string) => {
    return new URL(
      EndPoints.baseurl(`api/v1/users/pushNotification/${deviceId}`)
    );
  };

  static languageUrl = () => {
    return new URL(EndPoints.baseurl("api/v1/users/language"));
  };

  static notifyLoginUrl = () => {
    return new URL(EndPoints.baseurl("api/v1/users/notifyLogin"));
  };

  static notifyLogoutUrl = () => {
    return new URL(EndPoints.baseurl("api/v1/users/notifyLogout"));
  };

  static repeatAlertURL = (orgId: number): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/organizations/${orgId}/settings/notifications`)
    );
  };

  static residentActivityConfigURL = (): URL => {
    return EndPoints.withOptions(
      EndPoints.baseurl(`api/v1/residents/activityConfiguration`),
      {}
    );
  };

  static residentsActivitiesURL = (options: any): URL => {
    return EndPoints.withOptions(
      EndPoints.baseurl(`api/v1/residents/activities`),
      options
    );
  };

  static residentActivity = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/activity/record`));
  };

  static activitiesFeedback = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/activities/feedbacks`));
  };

  static residentPicture = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/picture`));
  };

  static userNotification = (userId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/${userId}/notification`));
  };

  static nodePresence = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/presence`));
  };
  static residentsRulesBatch = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/residents/rules/batch`));
  };

  static userTags = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/tag/userTag/devices`));
  };

  static usersDevicesBatchURL = (userIds): URL => {
    return EndPoints.withSameOption(
      EndPoints.baseurl(`api/v1/tag/userTag?`),
      userIds,
      "users"
    );
  };

  static getVitalsUserNearby = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/userNearby/status`));
  };
  static nodesNearbySettings = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/nodes/usersNearbyRoomBedConfig`));
  };

  static userTagSettings = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/tag/userTag/users/batch`));
  };

  static vitalsUserNearbySettings = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/userNearby/settings`));
  };

  static changeDevicesWifi = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/devices/wifi/ssid`));
  };

  static userMobileDevice = (): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/devices/configurations`));
  };
  static setUserMobileDevice = (userId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/${userId}/configurations`));
  };

  static registerUserMobileDevice = (userId: string): URL => {
    return new URL(EndPoints.baseurl(`api/v1/users/${userId}/devices`));
  };

  static unregisterUserMobileDevice = (
    userId: string,
    deviceId: string
  ): URL => {
    return new URL(
      EndPoints.baseurl(`api/v1/users/${userId}/devices/${deviceId}`)
    );
  };
  ////new auth
  static getAuthData = (): URL => {
    return new URL(EndPoints.authUrl(`api/account/profile`));
  };
  static rotateToken = (refreshToken: string): URL => {
    return new URL(
      EndPoints.authUrl(
        `api/account/token/refresh?refreshToken=${refreshToken}`
      )
    );
  };

  static loginPassword = (): URL => {
    return new URL(
      EndPoints.authUrl(`api/auth/flow/password/signIn?AppId=${APP_ID}`)
    );
  };

  static logout = (): URL => {
    return new URL(EndPoints.authUrl(`api/account/logout`));
  };

  static signInCheck = (username: string): URL => {
    return new URL(
      EndPoints.authUrl(
        `api/auth/signin/username?Username=${username}&AppId=${APP_ID}`
      )
    );
  };

  static passwordlessStart = (): URL => {
    return new URL(
      EndPoints.authUrl(`api/auth/flow/passwordless/signin/start`)
    );
  };
  static passwordlessEnd = (): URL => {
    return new URL(
      EndPoints.authUrl(`api/auth/flow/passwordless/signin/finish`)
    );
  };
}
